<template>
  <div class="input-feeling">
    <button
      v-for="option in options"
      :key="option.value"
      class="input-feeling__option"
      :class="{ 'input-feeling__option--selected': option.isSelected }"
      @click.prevent="selectOption(option)"
    >
      <img
        :src="require(`@/assets/img/main/icons/icon-feeling-${option.value}-component.svg`)"
        :alt="`Icon ${option.value}`"
      >

      <span>
        {{ option.label }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseInputFeeling',

  props: {
    value: {
      type: Array,
      default: []
    }
  },

  data () {
    return {
      options: [
        {
          label: 'Negativo',
          value: 'negative',
          isSelected: false
        },
        {
          label: 'Neutro',
          value: 'neutral',
          isSelected: false
        },
        {
          label: 'Positivo',
          value: 'positive',
          isSelected: false
        }
      ]
    }
  },

  computed: {
    optionsSelected () {
      return this.options
        .filter(option => option.isSelected == true)
        .map(option => option.value)
    }
  },

  mounted () {
    this.fillOptionsDefault()
  },

  methods: {
    selectOption (option) {
      option.isSelected = !option.isSelected

      Object.assign(this.options, option)

      this.$emit('input', this.optionsSelected)
    },

    fillOptionsDefault () {
      this.options = this.options.map(option => {
        if (this.value.includes(option.value)) {
          option.isSelected = true
        }

        return option
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.input-feeling {
  $border: 0.7px solid rgba(nth($colors-custom, 1), 0.5);
  $border-radius: 3.6px;

  display: inline-flex;
  border: $border;
  border-radius: $border-radius;

  &__option {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 47px;
    height: 36.5px;
    border: none;
    transition: all 0.1s;
    background: none;

    &:not(:first-child) {
      border-left: $border;
    }

    &:first-child {
      border-radius: $border-radius 0 0 $border-radius;
    }

    &:last-child {
      border-radius: 0 $border-radius $border-radius 0;
    }

    img {
      width: 20px;
    }

    span {
      position: absolute;
      bottom: -20px;
      left: 50%;
      opacity: 0;
      transform: translateX(-50%);
      transition: all 0.1s;
      font: {
        weight: 700;
        size: 11px;
      }
    }

    &--selected {
      background: nth($colors-custom, 10);

      span {
        opacity: 1;
      }
    }
  }
}
</style>
